import _SkipNext from "@mui/icons-material/SkipNext";
import _Forward from "@mui/icons-material/Forward10";
import _SkipPrevious from "@mui/icons-material/SkipPrevious";
import _Replay from "@mui/icons-material/Replay10";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { SIZES } from '@fupa/fupa-uikit';
import { PlaybackToggle } from 'app/components/tv/customControls/PlaybackToggle';
import { ButtonContainer, DEFAULT_ICON_STYLES } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import { useToggleVideoControlBar } from 'app/hooks/useToggleVideoControlBar';
const Wrapper = styled.div.withConfig({
  componentId: "sc-73kuec-0"
})(["position:absolute;top:0;left:0;height:100%;width:100%;display:", ";align-items:center;justify-content:center;font-size:", ";z-index:9998;opacity:", ";transition:opacity 0.5s;"], props => props.hide ? 'none' : 'flex', SIZES['24'], props => props.show ? '1' : '0');
export const DesktopControls = _ref => {
  let {
    adPlaying,
    playerRef,
    playerReady,
    playlist,
    handlePreviousVideo,
    handleNextVideo,
    videoContainerRef,
    currentVideoIndex,
    hide,
    isSeekable
  } = _ref;
  const {
    showControls,
    setShowControls
  } = useToggleVideoControlBar(playerRef, playerReady, currentVideoIndex, playlist, videoContainerRef, adPlaying);

  // show controls on pause
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !playerReady) {
      return;
    }
    const handlePlayerPause = () => setShowControls(true);
    player.on('pause', handlePlayerPause);
    return () => {
      if (player) {
        player.off('pause', handlePlayerPause);
      }
    };
  }, [playerReady]);

  // play/pause by space bar click
  useEffect(() => {
    const player = playerRef.current;
    if (!player || !playerReady || adPlaying) {
      return;
    }
    const handleKeyUp = event => {
      if (event.keyCode === 32) {
        // space bar pressed
        event.preventDefault();
        if (player.paused()) {
          player.play();
        } else {
          player.pause();
          setShowControls(true);
        }
      }
    };
    window.addEventListener('keyup', handleKeyUp);
    return () => window.removeEventListener('keyup', handleKeyUp);
  }, [playerReady, adPlaying]);
  return /*#__PURE__*/React.createElement(Wrapper, {
    show: showControls,
    hide: hide,
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "DesktopControls",
    "data-sentry-source-file": "DesktopControls.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: handlePreviousVideo,
    title: "Vorherige Szene",
    bgColor: true,
    dim: "2em",
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "DesktopControls.tsx"
  }, isSeekable ? /*#__PURE__*/React.createElement(_Replay, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  }) : /*#__PURE__*/React.createElement(_SkipPrevious, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  })), /*#__PURE__*/React.createElement(PlaybackToggle, {
    playerRef: playerRef,
    playerReady: playerReady,
    adPlaying: adPlaying,
    isBigPlayButton: true,
    bgColor: true,
    "data-sentry-element": "PlaybackToggle",
    "data-sentry-source-file": "DesktopControls.tsx"
  }), /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: handleNextVideo,
    title: "N\xE4chste Szene",
    bgColor: true,
    dim: "2em",
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "DesktopControls.tsx"
  }, isSeekable ? /*#__PURE__*/React.createElement(_Forward, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  }) : /*#__PURE__*/React.createElement(_SkipNext, {
    style: {
      ...DEFAULT_ICON_STYLES,
      fontSize: '1.5em'
    }
  })));
};